import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { Toast } from "primereact/toast";
import { useEffect } from "react";
import { useState } from "react";
import { useRef } from "react";
import React from "react";
import { Toolbar } from 'primereact/toolbar';
import { InputText } from 'primereact/inputtext';
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { classNames } from "primereact/utils";
import { useAuthHeader } from "../../auth/AuthService";
import { useTranslation } from "react-i18next";
import { Controller, useForm } from "react-hook-form";
import { createGroup, deleteGroup, retrieveGroups, updateGroup } from "../../Services/Admin/GroupApiService";
import { retrieveUser } from "../../Services/Admin/UserApiService";
import UserDataTable from "../../Components/Admin/User/userDataTable";
import { useContext } from "react";
import { LayoutContext } from "../../Layouts/Admin/layoutcontext";
        
export default function Group() {

    const {t, i18n} = useTranslation();
    const authHeader = useAuthHeader();
    const [groups, setGroups] = useState(null);
    const [groupDialog, setGroupDialog] = useState(false);
    const [showUserDialog, setShowUserDialog] = useState(false);
    const [deleteGroupDialog, setDeleteGroupDialog] = useState(false);
    const [group, setGroup] = useState({});
    const [edit, setEdit] = useState(false);
    const [selectedGroups, setSelectedGroups] = useState(null);
    const [submitted, setSubmitted] = useState(false);
    const [globalFilter, setGlobalFilter] = useState(null);
    const toast = useRef(null);
    const dt = useRef(null);
    const [filter, setFilter] = useState({'perPage': 10, 'page': 0 });
    const [userFilter, setUserFilter] = useState({'perPage': 10, 'page': 0 });
    const [firstPage, setFirstPage] = useState(0);
    const [userFirstPage, setUserFirstPage] = useState(0);
    const [loading, setLoading] = useState(false);
    const [users, setUsers] = useState([]);

    const { setMenuTitle } = useContext(LayoutContext);
    useEffect(() => {
        setMenuTitle('Groups');
    },[]);

    useEffect(() => {
        getGroup()
    }, [filter]);

    useEffect(() => {
        group?.id && getUser()
    }, [userFilter]);

    const getGroup = async () => {
        setLoading(true);
        await retrieveGroups(authHeader(), filter)
        .then((response) => {
            setGroups(response?.data?.data);
            setLoading(false);
        })
        .catch((error) => console.log(error));
    }

    const getUser = async () => {
        setLoading(true);
        await retrieveUser(authHeader(), userFilter)
        .then((response) => {
            setUsers(response?.data?.data);
            setLoading(false);
        })
        .catch((error) => console.log(error));
    }

    const onPageChange = (page) => {
        setFirstPage(page.first);
        setFilter({ ...filter,'perPage': page.rows, 'page': page.page});
    }

    const onSort = (sort) => {
        setFilter({...filter, 'sortField': sort.sortField, 'sortOrder': sort.sortOrder});
    }

    const openNew = () => {
        setEdit(false);
        reset(defaultValues);
        setSubmitted(false);
        setGroupDialog(true);
    };

    const hideDialog = () => {
        setSubmitted(false);
        setGroupDialog(false);
    };

    const hideDeleteGroupDialog = () => {
        setDeleteGroupDialog(false);
    };

    const editGroup = (group) => {
        setEdit(true);
        reset({
            id: group.id,
            name: group.name,
            role: group.role,
        });
        setGroup({ ...group });
        setGroupDialog(true);
    };

    const confirmDeleteGroup = (group) => {
        setGroup(group);
        setDeleteGroupDialog(true);
    };

    const previewGroup = (group) => {
        setUserFilter({...userFilter, 'groupId': group?.id});
        setGroup(group);
        setShowUserDialog(true);
    }

    const exportCSV = () => {
        dt.current.exportCSV();
    };

    const leftToolbarTemplate = () => {
        return (
            <div className="flex flex-wrap gap-2">
                <Button label={t("New")} icon="pi pi-plus" severity="success" onClick={openNew} />
            </div>
        );
    };

    const rightToolbarTemplate = () => {
        return header;
    };

    const actionBodyTemplate = (rowData) => {
        return (
            <React.Fragment>
                <Button icon="pi pi-eye" rounded outlined className="mr-2" style={{height:'2rem', width:'2rem'}} onClick={() => previewGroup(rowData)} />
                <Button icon="pi pi-pencil" rounded outlined className="mr-2" style={{height:'2rem', width:'2rem'}} onClick={() => editGroup(rowData)} />
                <Button icon="pi pi-trash" rounded outlined severity="danger" style={{height:'2rem', width:'2rem'}} onClick={() => confirmDeleteGroup(rowData)} />
            </React.Fragment>
        );
    };

    const dataFormat = (date) => {
        return (date.getDate() < 10 ? "0" : "") + date.getDate() + '-' + t(date.toLocaleString('default', { month: 'short' })) + '-' + date.getFullYear()
    }

    const onChangeSearch = (e) => {
        setGlobalFilter(e.target.value);
        setFilter({
            ...filter,
            'search': e.target.value
        })
    }

    const header = (
        <div className="flex flex-wrap gap-2 align-items-center justify-content-between">
            <div className="flex">
                <span className="p-input-icon-left">
                    <i className="pi pi-search" />
                    <InputText type="search" onInput={onChangeSearch} placeholder="Search..." className="w-full" />
                </span>
            </div>
        </div>
    );

    const OnDeleteGroup = async () => {
        group.id && await deleteGroup(authHeader(), group.id)
            .then((response) => {
                if (response.status === 200) {
                    getGroup()
                    toast.current.show({ severity: 'info', detail: "User Deleted!", life: 3000 });
                } 
            })
            .catch((error) => {
                toast.current.show({ severity: 'error', detail: "Something went wrong!", life: 3000 });
            });
        setDeleteGroupDialog(false);
    };

    const deleteGroupDialogFooter = (
        <React.Fragment>
            <Button label="No" icon="pi pi-times" outlined onClick={hideDeleteGroupDialog} />
            <Button label="Yes" icon="pi pi-check" severity="danger" onClick={OnDeleteGroup} />
        </React.Fragment>
    );

    const defaultValues = {
        id: undefined,
        name: '',
        role: '',
    };

    const {
        control,
        formState: { errors },
        handleSubmit,
        reset,
        setError
    } = useForm({ defaultValues });

    const getFormErrorMessage = (name) => {
        return errors[name] ? <small className="p-error pt-1 pb-3 text-left">{errors[name].message}</small> : <small className="p-error">&nbsp;</small>;
    };

    Date.prototype.addDays = function(days) {
        var date = new Date(this.valueOf());
        date.setDate(date.getDate() + days);
        return date;
    }

    const onSubmit = async (data) => {
        
        if (edit && data.id) {
            await updateGroup(authHeader(), data, data.id)
            .then((response) => {
                if (response.status === 200) {
                    hideDialog();
                    getGroup()
                    toast.current.show({ severity: 'info', detail: "Group Updated!", life: 3000 });
                    reset(defaultValues)
                } 
            })
            .catch((error) => {
                if (error?.response?.status === 400) {
                    setError('name', {
                        type: "server",
                        message: error?.response?.data?.data,
                    });
                }
            });
        } else {
            await createGroup(authHeader(), data)
            .then((response) => {
                console.log(response?.data?.respCd);
                if (response?.data?.respCd === "0000") {
                    hideDialog();
                    getGroup()
                    toast.current.show({ severity: 'info', detail: "Group Created!", life: 3000 });
                    reset(defaultValues)
                } else if (response?.data?.respCd === "208") {
                    setError('name', {
                        type: "server",
                        message: response?.data?.message,
                    });
                }
            })
            .catch((error) => console.log(error));
        }
        
    };
    
    return (
        <>
        {/* <div className="grid crud-demo">
            <div className="col-12"> */}
                <Toast ref={toast} />
                {/* <div className="card"> */}
                    <Toolbar className="mb-2" start={leftToolbarTemplate} end={rightToolbarTemplate}></Toolbar>

                    <DataTable ref={dt} value={groups?.content}
                            dataKey="id"  paginator rowsPerPageOptions={[5, 10, 25, 50]}
                            lazy
                            first={firstPage}
                            rows={filter.perPage}
                            totalRecords={groups?.totalElements}
                            onPage={onPageChange}
                            onSort={onSort}
                            sortField={filter.sortField}
                            sortOrder={filter.sortOrder}
                            loading={loading}
                            paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                            currentPageReportTemplate="Showing {first} to {last} of {totalRecords} users"
                            className="text-sm"
                    >
                        <Column field="id" header={t("ID")} headerClassName="font-bold" sortable></Column>
                        <Column field="name" header={t("Name")} headerClassName="font-bold" sortable ></Column>
                        <Column field="role" header={t("Role")} headerClassName="font-bold" sortable ></Column>
                        <Column field="created" header={t("Created")} headerClassName="font-bold" body={(e) => e.created && dataFormat(new Date(e.created))} sortable ></Column>
                        <Column field="modified" header={t("Modified")} headerClassName="font-bold" body={(e) => e.modified && dataFormat(new Date(e.modified))} sortable></Column>
                        <Column header={t("Actions")} headerClassName="font-bold" body={actionBodyTemplate} style={{minWidth: '9rem'}} exportable={false} ></Column>
                    </DataTable>
                {/* </div> */}

                <Dialog visible={groupDialog} style={{ width: '32rem' }} breakpoints={{ '960px': '75vw', '641px': '90vw' }} header={edit ? 'Edit Group' : "Add Group"} modal className="p-fluid" onHide={hideDialog}>
                    <form onSubmit={handleSubmit(onSubmit)} className="pt-2 flex flex-column w-full">
                        <div className='grid'>
                            <Controller
                                name="id"
                                control={control}
                                render={({ field }) => (
                                    <input type="hidden" value={field.value}></input>
                                )}
                            />
                            <Controller
                                name="name"
                                control={control}
                                rules={{ 
                                    required: 'Name is required.',
                                }}
                                render={({ field, fieldState }) => (
                                    <div className="col-6">
                                        <span className="p-float-label w-full">
                                            <InputText id="name" value={field.value} className={classNames({ 'p-invalid': fieldState.error })+" w-full bg-login-card"} onChange={(e) => field.onChange(e.target.value)} />
                                            <label htmlFor="name" className="bg-login-card z-5">{t('Name')}</label>
                                        </span>
                                        {getFormErrorMessage(field.name)}
                                    </div>
                                )}
                            />
                            <Controller
                                name="role"
                                control={control}
                                rules={{ 
                                    required: 'Role is required.',
                                }}
                                render={({ field, fieldState }) => (
                                    <div className="col-6">
                                        <span className="p-float-label w-full">
                                            <InputText id="role" value={field.value} className={classNames({ 'p-invalid': fieldState.error })+" w-full bg-login-card"} onChange={(e) => field.onChange(e.target.value)} />
                                            <label htmlFor="role" className="bg-login-card z-5">{t('Role')}</label>
                                        </span>
                                        {getFormErrorMessage(field.name)}
                                    </div>
                                )}
                            />
                        </div>
                        <div className="flex justify-content-end">
                            <Button type="submit" label={t("Submit")} className="w-4 p-3 text-xl" ></Button>
                        </div>
                    </form>
                </Dialog>

                <Dialog visible={showUserDialog} style={{ width: '100rem' }} breakpoints={{ '960px': '75vw', '641px': '90vw' }} header={() => <span style={{fontWeight: "700"}}>Group Review</span>} modal className="p-fluid" onHide={() => setShowUserDialog(false)}>
                    <div className="grid">
                        <div className="col-4">
                            <div className="flex flex-column gap-1 mb-3">
                                <span>{t('ID')}</span>
                                <span className="font-bold">{group?.id}</span>
                            </div>
                            <div className="flex flex-column gap-1 mb-3">
                                <span>{t('Created')}</span>
                                <span className="font-bold">{group.created && dataFormat(new Date(group.created))}</span>
                            </div>
                        </div>
                        <div className="col-4">
                            <div className="flex flex-column gap-1 mb-3">
                                <span>{t('Name')}</span>
                                <span className="font-bold">{group?.name}</span>
                            </div>
                            <div className="flex flex-column gap-1 mb-3">
                                <span>{t('Modified')}</span>
                                <span className="font-bold">{group.modified && dataFormat(new Date(group.modified))}</span>
                            </div>
                        </div>
                        <div className="col-4">
                            <div className="flex flex-column gap-1 mb-3">
                                <span>{t('Role')}</span>
                                <span className="font-bold">{group?.role}</span>
                            </div>
                        </div>
                        <div className="col-12 border-top-1 border-300"></div>
                        <div className="pl-2 text-xl font-bold">{t('Relate Users')}</div>
                        <div className="col-12">
                            <UserDataTable groupId={group?.id}></UserDataTable>
                        </div>

                        
                    </div>
                </Dialog>

                <Dialog visible={deleteGroupDialog} style={{ width: '32rem' }} breakpoints={{ '960px': '75vw', '641px': '90vw' }} header="Delete Group" modal footer={deleteGroupDialogFooter} onHide={hideDeleteGroupDialog}>
                    <div className="confirmation-content">
                        {group && (
                            <span>
                                {t('Are you sure you want to delete')} <b>{group.name}</b>?
                            </span>
                        )}
                    </div>
                </Dialog>
            {/* </div>
        </div> */}
        </>
    )
}